export default __webpack_public_path__ + "static/media/experts1.d180fb55.jpg";